export default "__VITE_ASSET__779411a7__"